import React, { useEffect, useState } from 'react';

//import { useParams } from 'react-router-dom';
import { addQuestionToItem } from './ItemService';
import { getAllQuestions } from '../Questions/QuestionService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
//import listItemChildren from './ItemChildrenList';

// const AttachChildren = ({ listItemChildren, parentId, sectionId }) => {
const AttachItemQuestion = ({ listItemQuestions, itemId }) => {
  const [open, setOpen] = useState(false);
  const [questions, setQuestions] = useState<any[]>([]);
  // const navigate = useNavigate();

  // const [questionContent, setQuestionContent] = useState('');
  // const [description, setDescription] = useState('');
  // const [contactPerson, setContactPerson] = useState('');
  // const [location, setLocation] = useState('');
  // const [status, setStatus] = useState('');

  const [selectedQuestionId, setSelectedQuestionId] = useState(null);

  const handleChange = (questionId) => {
    setSelectedQuestionId(questionId);
  };

  const handleClickOpen = () => {
    listItemQuestions();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listQuestions();
  }, [itemId]);

  function listQuestions() {
    getAllQuestions()
      .then((response) => {
        setQuestions(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedQuestion(itemId, questionId) {
    //const document = {name, description, contactPerson, location, status};

    addQuestionToItem(itemId, questionId)
      .then(() => {
        // appProgrammeList();
        listItemQuestions();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select Question</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedQuestionId || ''} // Use selectedItemId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select Item
                </option>
                {/* Map over items to generate options */}
                {questions.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.questionContent}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() => attachSelectedQuestion(itemId, selectedQuestionId)}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachItemQuestion;
